import React from 'react';
import TeamsChannelModel from './teamsBody';
import EditSlackChannelModel, { SlackChannelConfig } from './editSlackModel';
import EditTeamsChannelModel from './editTeamsModel';

type channelProps = {
  id?: string
  channel: string,
  name?: string,
  isAlert: boolean,
  isDefault: boolean,
  ownerId: string,
  authInfo?: SlackChannelConfig,
  organizationId?: string,
  onHide: ()=>void,
  isReload: ()=>void
}

const EditChannelMainBody = (
  {
    id,
    channel,
    name,
    isAlert,
    isDefault,
    ownerId,
    organizationId,
    authInfo,
    onHide,
    isReload,
  }: channelProps,
) => (
    <>
    { ((channel as string).toLowerCase() === 'ms teams')
        && (
        <EditTeamsChannelModel
          id={id}
          channel={channel}
          name={name}
          isAlert={isAlert}
          isDefault={isDefault}
          ownerId={ownerId}
          organizationId={organizationId}
          authInfo={authInfo}
          onHide={onHide}
          isReload={isReload}
        />
        )}
    { ((channel as string).toLowerCase() === 'slack')
        && (
        <EditSlackChannelModel
          id={id}
          channel={channel}
          name={name}
          isAlert={isAlert}
          isDefault={isDefault}
          ownerId={ownerId}
          organizationId={organizationId}
          authInfo={authInfo}
          onHide={onHide}
          isReload={isReload}
        />
        )}
    </>
);

export default EditChannelMainBody;